<template>
  <div class="pan-zoom-overlay">
    <p class="instructions">Optionally add two or more pan/zoom points along the timeline to transition between them.</p>
    <div class="overlay-button" v-on:click="resetDefault" :class="{ disabled: vdPositions == [] }">Reset Default</div>
    <div class="overlay-button" v-on:click="removePoint" :class="{ disabled: selectedPoint == null }">Remove Point</div>
    <div class="overlay-button" v-on:click="addPoint">Add Pan/Zoom Point</div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: "PanZoom",
  props: ["editor"],
  computed: {
    vdPositions: {
      get() {
        return this.editor.vdPositions;
      },
      set(value) {
        this.editor.vdPositions = value;
      }
    },
    vdArray: {
      get() {
        return this.editor.video.customVirtualDirector;
      },
      set(value) {
        this.editor.video.customVirtualDirector = value;
      }
    }
  },
  data: function() {
    return {
      selectedPoint: null,
    }
  },
  methods: {
    addPoint: function(e) {
      if (e.target.classList.contains("disabled")) {
        return false;
      }

      const player = this.$parent.$parent;
      const videoJSPlayer = player.$refs.videoJSComponent.videoJSPlayer;
      const that = this;

      let position = {
        time: videoJSPlayer.currentTime(),
        startFrame: videoJSPlayer.currentTime() * videoJSPlayer.fps,
        x: videoJSPlayer.x,
        y: videoJSPlayer.y,
        scale: videoJSPlayer.currentZoom
      }

      that.vdPositions.push(position);

      videoJSPlayer.trigger("addPanZoomMarker", position);

      position.element.addEventListener("click", event => {
        if (event.target.classList.contains("selected")) {
          event.target.classList.remove("selected");
          that.selectedPoint = null;
        } else {
          var oldMarker = document.getElementsByClassName("pz-marker")[0];
          oldMarker.classList.remove("selected");
          event.target.classList.add("selected")
          that.selectedPoint = event.target;
        }
      });

      //start frame, how long it stays there...

      this.vdPositions = _.sortBy(this.vdPositions, 'time');

      //get duration by finding difference between each position and the next, or the end
      this.vdPositions.forEach((element, index) => {
        element.duration = 1;
      });

      let vdArray = [];

      this.vdPositions.forEach((element, index, array) => {
        vdArray.push([element.startFrame, element.duration, element.x, element.y, element.scale])
      });

      this.vdArray = vdArray;
    },
    removePoint: function(e) {
      if (e.target.classList.contains("disabled")) {
        return false;
      }
      this.selectedPoint.parentNode.removeChild(this.selectedPoint);
      _.pull(this.vdPositions, this.selectedPoint.pzData);
      this.selectedPoint = null;
    },
    resetDefault: function(e) {
      if (e.target.classList.contains("disabled")) {
        return false;
      }
      this.selectedPoint = null;
      this.vdPositions.forEach((position) => {
        position.element.parentNode.removeChild(position.element);
      });
      this.vdPositions = [];
      this.vdArray = [];
    },

  }
};
</script>

<style lang="stylus" scoped>
  .pan-zoom-overlay
    display: flex
    padding: 0px 30px
    height: 100%
    align-items: center
    justify-content: space-around
  .overlay-button
    color: #FFF
    font-weight: bold
    cursor: pointer
    font-size: 12px
    padding: 10px
    margin-right: 10px
    border-radius: 10px
    border: 1px solid rgba(255,255,255,.55)
    transition: all 250ms
    &.disabled
      color: rgba(255,255,255,.25)
      border: 1px solid rgba(255,255,255,.25)
    &:last-of-type
      margin-right: 0px
    &:not(.disabled):hover
      border: 1px solid rgba(255,255,255,1)
  p
    color: #FFF
</style>
